var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('share-frame',{staticClass:"expense-summary-asset"},[_c('expense-summary-core',{attrs:{"presented-month":_vm.presentedMonth,"all-expenses":_vm.allExpenses}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }